import { render } from "./Settings.vue?vue&type=template&id=5df4a43e&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-5df4a43e"

export default script